webpackJsonp([213720915766396],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(54);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _separator = __webpack_require__(24);
	
	var _separator2 = _interopRequireDefault(_separator);
	
	var _styledTexts = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Projects = function Projects() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _styledTexts.MyH1,
	      null,
	      'Projects'
	    ),
	    _react2.default.createElement(
	      _styledTexts.MyP,
	      null,
	      'Here is a (constantly growing) list of projects that I am working on or have completed.'
	    ),
	    _react2.default.createElement(
	      _styledTexts.MyH2,
	      null,
	      'Things I\'ve Done'
	    ),
	    _react2.default.createElement(
	      _styledTexts.MyUl,
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/docs/survey-viewing-habits-poster.pdf' },
	          _react2.default.createElement(
	            'i',
	            null,
	            '"What Do CMU Students Watch and How Do They Watch It?"'
	          )
	        ),
	        '-- a poster created for final project of 36-303 Surveys, Sampling, and Society.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'http://reroche.github.io/github-instructions' },
	          _react2.default.createElement(
	            'i',
	            null,
	            'Introduction to GitHub for CMU Students'
	          )
	        ),
	        ', a website created for my final project of 76-270 Writing for the Professions.',
	        ' '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Coursera and Andrew Ng\'s',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://deeplearning.ai' },
	          'deeplearning.ai'
	        ),
	        ' specialization. My certificate can be found',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.coursera.org/account/accomplishments/specialization/certificate/8QRL2F2FAUHY' },
	          'here'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'http://reroche.github.io/startpage/' },
	          'Simple startpage'
	        ),
	        ' for my browser developed using React. Code available',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://github.com/reroche/startpage/' },
	          'here'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: '/docs/mnist_cnn.html' },
	          _react2.default.createElement(
	            'i',
	            null,
	            'Convolutional Neural Network for Digit Recognition using the MNIST Dataset'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Poster for ',
	        _react2.default.createElement(
	          'i',
	          null,
	          'Meeting of the Minds 2017'
	        ),
	        ', Carnegie Mellon University\'s Undergraduate Research Symposium.',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: '/docs/motm_poster.pdf' },
	          _react2.default.createElement(
	            'i',
	            null,
	            'Identifying Contact Binaries in the Catalina Real-Time Transient Survey'
	          )
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'My \'native\' version of',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://github.com/reroche/todoist-dark-linux' },
	          'Todoist for Linux'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'http://github.com/reroche/stack_dump' },
	          'StackDump'
	        ),
	        ', a React Native productivity app that I developed for a course at Carnegie Mellon University.'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'My final project for ',
	        _react2.default.createElement(
	          'i',
	          null,
	          '36-315 Graphics and Visualization'
	        ),
	        ' at CMU. The ',
	        _react2.default.createElement(
	          'i',
	          null,
	          'R Shiny'
	        ),
	        ' web app can be found',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://reroche.shinyapps.io/final_project/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(_separator2.default, null)
	  );
	}; /* eslint-disable */
	
	
	Projects.propTypes = {
	  data: _propTypes2.default.any
	};
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-138a20ac694f06684c60.js